import { render } from "./TeamsReport.vue?vue&type=template&id=050c68ef&scoped=true"
import script from "./TeamsReport.vue?vue&type=script&lang=js"
export * from "./TeamsReport.vue?vue&type=script&lang=js"

import "./TeamsReport.vue?vue&type=style&index=0&id=050c68ef&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-050c68ef"

export default script